import {combine, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {
    setLastCreatedDocumentId,
    stopDocumentInGridPolling,
    waitDocumentInGridAndRedirectFx,
} from '../index';

import {data$} from './tables/childrenCodes';

import {
    aggregationForm$,
    aggregationFormChanged,
    aggregationFile$,
    aggregationFileChanged,
    AggregationGate,
    createAggregationDocument,
    sendAggregationFx,
    step$,
    stepChanged,
} from './index';

sample({
    clock: AggregationGate.close,
    target: stopDocumentInGridPolling,
});

aggregationForm$
    .on(aggregationFormChanged, (state, payload) => ({...state, ...payload}))
    .reset(AggregationGate.close);
aggregationFile$.on(aggregationFileChanged, (_, payload) => payload).reset(AggregationGate.close);
step$.on(stepChanged, (_, payload) => payload).reset(AggregationGate.close);

sample({
    clock: createAggregationDocument,
    source: combine({
        form: aggregationForm$,
        codes: data$.map((p) => p.map((d) => d.identityCode)),
        file: aggregationFile$,
    }),
    fn: ({form, codes, file}) => ({
        ...form,
        ...(codes.length && {codes}),
        ...(file && {file}),
    }),
    target: sendAggregationFx,
});

sendAggregationFx.fail.watch(({error}) => showRestError(error as RestError));

sendAggregationFx.done.watch((data) => {
    aggregationFileChanged(null);

    const id = data.result?.data?.data?.reportId || '';
    setLastCreatedDocumentId(id);
    waitDocumentInGridAndRedirectFx(id);
});
